<template>
  <div>
    <div class="d-flex gap-3">
      <div style="flex: 2">
        <PlatformSelector
          v-model="platforms"
          label="Selecione uma ou mais plataformas"
          multiple
          selectAll
        />
      </div>
      <div style="flex: 1">
        <v-select
          v-model="year"
          :items="years"
          label="Ano"
          hide-details
          outlined
          dense
        ></v-select>
      </div>
    </div>

    <v-alert type="error" v-if="error" text class="mt-3 mb-0">
      {{ error }}
      <v-spacer></v-spacer>
      <v-btn @click="getReport" color="error" small depressed>
        <v-icon>mdi-refresh</v-icon>
        Tentar novamente
      </v-btn>
    </v-alert>
    <v-alert type="info" v-if="platforms.length === 0" class="mt-3 mb-0" text>
      Selecione uma plataforma para ver o relatório.
    </v-alert>
    <v-alert type="info" v-else-if="!year" class="mt-3 mb-0" text>
      Selecione um ano para ver o relatório.
    </v-alert>
    <v-row v-else-if="!error">
      <v-col cols="12">
        <v-alert type="warning" class="mb-0" text>
          <b>Aviso Importante:</b> Este relatório está em fase de validação e
          seus dados podem não estar totalmente precisos. Por favor, aguarde a
          validação completa antes de utilizar estas informações.
        </v-alert>
      </v-col>
      <v-col v-if="loading" cols="12">
        <v-card loading elevation="0">
          <v-alert type="info" class="mb-0" text>
            Os dados estão sendo atualizados. Por favor, aguarde.
          </v-alert>
        </v-card>
      </v-col>
      <v-col cols="12">
        <MonthResume
          :data="reportData.payments"
          :loading="loading"
          direction="row"
          month="Total"
          :year="year"
        />
      </v-col>
      <v-col
        v-for="month in monthsReport"
        :key="month.month"
        cols="12"
        md="6"
        lg="3"
      >
        <MonthResume
          :month="month.month"
          :loading="loading"
          :data="month.data"
          :year="year"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import FINANCIAL from "@/services/admin/financial";
import MonthResume from "./modules/MonthResume.vue";
import PlatformSelector from "@/components/global/PlatformSelector.vue";

export default {
  components: { MonthResume, PlatformSelector },
  data: () => ({
    reportData: {},
    error: null,
    loading: false,
    platforms: [],
    year: null,
    timeout: null,
    months: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ],
    years: Array.from({ length: 10 }, (_, i) => moment().year() - i),
  }),
  methods: {
    async scheduleGetReport() {
      if (this.timeout) clearTimeout(this.timeout);
      if (!this.platforms.length || !this.year) return;
      this.loading = true;
      this.error = null;

      this.timeout = setTimeout(this.getReport, 1500);
    },
    async getReport() {
      try {
        if (!this.platforms.length || !this.year) return;
        this.error = null;
        this.loading = true;

        const data = await FINANCIAL.getReportByMonth(
          this.platforms.map((p) => p.id).join(","),
          this.year
        );
        this.reportData = data;
      } catch (e) {
        this.error = e.message || "Erro ao carregar relatório";
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    platforms() {
      this.scheduleGetReport();
    },
    year() {
      this.scheduleGetReport();
    },
  },
  computed: {
    ...mapGetters("auth", ["hasPermission"]),
    monthsReport() {
      return this.months.map((month, index) => {
        return {
          month,
          data: this.reportData?.payments?.filter(
            (payment) => parseInt(payment.month.split("-")[1]) === index + 1
          ),
        };
      });
    },
  },
};
</script>

<style></style>
